import { LeadsFilter } from "@/model/lead";

export const defaultLeadsFilterFields: LeadsFilter = {
  status_id: undefined,
  source_id: undefined,
  responsible_user_id: undefined,
  created_at_from: undefined,
  created_at_to: undefined,
  search: undefined,
};
